<div class="row">
  <div class="col-12 col-auto">
    <div class="card">
      <div class="card-header">
        <form class="p-2" #chartForm="ngForm">
          <div class="row">
            <div class="col-auto">
              <div class="input-group mb-2">
                <button
                  for="SelectAttributes"
                  class="btn btn-outline-primary btn-sm"
                >
                  Field
                </button>
                <select
                  class="form-select form-select-sm"
                  id="SelectAttributes"
                  name="SelectAttributes"
                  [(ngModel)]="form.data['code']"
                  #SelectAttributes
                >
                  <option value="undefined">--Select--</option>
                  <option
                    *ngFor="let e of filterAttributes()"
                    value="{{ e['code'] }}"
                  >
                    {{ e["label"] }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-auto">
              <div class="input-group mb-2">
                <button for="chartType" class="btn btn-outline-primary btn-sm">
                  Chart
                </button>
                <select
                  class="form-select form-select-sm"
                  id="chartType"
                  name="chartType"
                  [(ngModel)]="form.data['chart']"
                  #chartType
                >
                  <option value="undefined">--Select--</option>
                  <option value="table">Table</option>
                  <option value="line">Line</option>
                  <option value="bar">Bar</option>
                  <option value="pie">Pie</option>
                  <option value="doughnut">Doughnut</option>
                </select>
              </div>
            </div>
            <div class="col-auto">
              <div class="input-group mb-2">
                <button for="aggType" class="btn btn-outline-primary btn-sm">
                  Type
                </button>
                <select
                  class="form-select form-select-sm"
                  id="aggType"
                  name="aggType"
                  [(ngModel)]="form.data['type']"
                  #aggType
                >
                  <option value="undefined">--Select--</option>
                  <option value="value">Value</option>
                  <option value="range">Range</option>
                </select>
              </div>
            </div>
            <div class="col-auto">
              <div class="form-check mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="percentageCheckbox"
                  [(ngModel)]="form.data['showPercentage']"
                  name="showPercentage"
                />
                <label class="form-check-label" for="percentageCheckbox">
                  %
                </label>
              </div>
            </div>

            <div class="col-auto d-flex align-items-center">
              <button
                class="btn btn-outline-primary btn-sm"
                (click)="drawChart()"
                title="Draw Chart"
                [disabled]="
                  form.data['code'] === 'undefined' ||
                  form.data['code'] === undefined ||
                  form.data['chart'] === 'undefined' ||
                  form.data['chart'] === undefined ||
                  form.data['type'] === 'undefined' ||
                  form.data['type'] === undefined
                "
              >
                Draw
              </button>

              <button
                class="btn btn-outline-primary btn-sm ms-1"
                title="Favourite"
                (click)="resetFavForm()"
                data-bs-toggle="modal"
                data-bs-target="#addFavouriteModal"
                [disabled]="
                  form.data['code'] === 'undefined' ||
                  form.data['code'] === undefined ||
                  form.data['chart'] === 'undefined' ||
                  form.data['chart'] === undefined ||
                  form.data['type'] === 'undefined' ||
                  form.data['type'] === undefined
                "
              >
                <i class="fadeIn animated bx bx-star"></i>
              </button>
              <button
                title="Favourite List"
                (click)="GetFavouriteList()"
                class="btn btn-outline-primary btn-sm ms-1"
                data-bs-toggle="modal"
                data-bs-target="#favListModal"
              >
                <i class="fadeIn animated bx bx-star"></i> List
              </button>
            </div>
          </div>
        </form>
      </div>

      <div
        *ngIf="chartdata && this.form.data.chart != 'table'"
        class="col col-auto"
      >
        <div class="container" [ngStyle]="{ width: chartContainerWidth }">
          <app-ncs-chart
            [chartType]="this.form.data.chart"
            [data]="chartdata"
            [options]="chartOptions"
          >
          </app-ncs-chart>
        </div>
      </div>

      <div
        *ngIf="chartdata && this.form.data.chart === 'table'"
        class="col col-auto"
      >
        <div class="container">
          <app-ncs-chart-table
            [data]="chartdata"
            *ngIf="this.form.data.chart === 'table'"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Favourite List Modal -->
<div
  class="modal fade"
  id="favListModal"
  tabindex="-1"
  aria-labelledby="favListModal"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="favListModal">Favourite List</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          title="Close"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p *ngIf="favForm['error'] == false && favForm['listMessage']">
          <app-ncs-alert [message]="favForm['listMessage']" type="success" />
        </p>
        <p *ngIf="favForm['error'] == true && favForm['listMessage']">
          <app-ncs-alert [message]="favForm['listMessage']" type="danger" />
        </p>
        <table class="table">
          <thead class="table table-responsive table-light">
            <tr>
              <th>S.No.</th>
              <th>Title</th>
              <th>Form</th>
              <th>Field</th>
              <th>Chart Type</th>
              <th>Type</th>
              <th>Percentage</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody align="left">
            <tr *ngFor="let e of favList; let i = index">
              <td>{{ pageIndex(i) }}</td>
              <td>{{ e.title }}</td>
              <td>{{ e.formTitle }}</td>
              <td>
                <span>
                  <li *ngFor="let item of e.chartJson">{{ item.code }}</li>
                </span>
              </td>
              <td>
                <span>
                  <li *ngFor="let item of e.chartJson">{{ item.chart }}</li>
                </span>
              </td>
              <td>
                <span>
                  <li *ngFor="let item of e.chartJson">{{ item.type }}</li>
                </span>
              </td>
              <td>
                <li *ngFor="let item of e.chartJson">
                  {{ item.showPercentage === true ? "Yes" : "No" }}
                </li>
              </td>
              <td>
                <button
                  title="View"
                  class="btn btn-sm btn-outline-primary me-1"
                  (click)="viewChart(e)"
                  data-bs-dismiss="modal"
                >
                  <i class="bi bi-eye fs-6 m-0 p-0"></i>
                </button>
                <button
                  title="Delete"
                  class="btn btn-sm btn-outline-danger me-1"
                  (click)="deleteFavData(e.id)"
                >
                  <i class="fa fa-trash fs-6 m-0 p-0"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          title="Close"
          data-bs-dismiss="modal"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Favourite add Modal -->
<div
  class="modal fade"
  id="addFavouriteModal"
  tabindex="-1"
  aria-labelledby="addFavouriteModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="addFavouriteModalLabel">
          Favourite Form
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          title="Close"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p *ngIf="favForm['error'] == false && favForm['message']">
          <app-ncs-alert [message]="favForm['message']" type="success" />
        </p>
        <p *ngIf="favForm['error'] == true && favForm['inputerror']">
          <app-ncs-alert
            [message]="favForm['inputerror'] | json"
            type="danger"
          />
        </p>
        <form #uform="ngForm">
          <div class="mb-3">
            <label for="name" class="form-label">Title</label>
            <input
              [(ngModel)]="favForm.data['title']"
              type="text"
              class="form-control"
              id="title"
              name="title"
              required
            />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          [disabled]="!uform.valid"
          type="button"
          class="btn btn-outline-primary btn-sm"
          title="Save"
          (click)="addFavourite()"
        >
          <i class="fa fa-save"></i> Save
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          data-bs-dismiss="modal"
          title="Close"
        >
          <i class="fa fa-window-close"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>
